// TOP LEVEL IMPORTS
import {gql} from '@apollo/client';

export default gql`
  mutation logout {
    logout
  }
`;
